import axios from '@axios'

export default {
  namespaced: true,
  state: {
    cliente: {
      nome_cliente: '',
      tipo_pessoa_cliente: 'F',
      documento_cliente: '',
      ativo_cliente: null,
      login_usuario: '',
      senha_usuario: '',
      endereco_cliente_endereco: '',
      numero_cliente_endereco: '',
      complemento_cliente_endereco: '',
      cep_cliente_endereco: '',
      bairro_cliente_endereco: '',
      cidade_cliente_endereco: '',
      inscricao_estadual_cliente_endereco: '',
      pais_id_cliente_endereco: null,
      uf_id_cliente_endereco: null,
      id_grupousuario: null,
    },
    clientes: [],
  },
  getters: {},
  mutations: {
    ADD_CLIENTE(state, cliente) {
      state.clientes.unshift(cliente)
    },
    SET_CLIENTE_DATA(state, cliente) {
      state.cliente = cliente
    },
  },
  actions: {
    fetchCleintes(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/clientes', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    saveCliente(ctx, clienteData) {
      axios.post('/clientes/save', clienteData).then(response => {
        if (response.status === 201) {
          ctx.commit('ADD_CLIENTE', response.data)
        }
      })
    },
    updateCliente(ctx, clienteData) {
      const {
        senha_usuario, login_usuario, documento_cliente, ...dataCliente
      } = clienteData
      axios.put(`/clientes/update/${clienteData.id_cliente}`, {
        ...dataCliente,
        cidade_cliente_endereco: clienteData.cidade_cliente_endereco.id,
        uf_id_cliente_endereco: clienteData.uf_id_cliente_endereco.id,
      }).then(response => {
        if (response.status === 200) {
          ctx.commit('SET_CLIENTE_DATA', response.data)
        }
      })
    },
    fetchCliente(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/clientes/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    findClienteById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/clientes/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteCliente(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/clientes/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addCliente(ctx, categoryData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/clientes', categoryData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updatedCliente(ctx, categoryData) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/clientes/${categoryData.id}`, categoryData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
